export default {"src":"/_next/static/media/cr.dcf9ce38.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};